"use client";

import React, { useMemo } from "react";
import { AttachmentTray as UIAttachmentTray } from "@/ui";
import type {
  AttachmentValidationError,
  PendingAttachment,
} from "@/lib/sola/attachments/types";

interface SolaAttachmentTrayProps {
  pending: PendingAttachment[];
  errors: AttachmentValidationError[];
  onRemove: (localId: string) => void;
  onDismissError: (index: number) => void;
}

/**
 * SOLA adapter for the design-system AttachmentTray. Maps the chat
 * lifecycle types onto the generic tray contract.
 */
export const AttachmentTray = React.memo(function AttachmentTray({
  pending,
  errors,
  onRemove,
  onDismissError,
}: SolaAttachmentTrayProps) {
  const items = useMemo(
    () =>
      pending.map((p) => ({
        id: p.localId,
        filename: p.filename,
        mediaType: p.mediaType,
        size: p.size,
        status:
          p.status === "uploaded"
            ? ("ready" as const)
            : p.status === "uploading"
              ? ("uploading" as const)
              : ("error" as const),
        thumbnailUrl: p.uploaded?.url ?? p.previewUrl ?? undefined,
        error: p.error,
      })),
    [pending]
  );

  return (
    <UIAttachmentTray
      items={items}
      errors={errors}
      onRemove={onRemove}
      onDismissError={onDismissError}
    />
  );
});
